module.exports = __webpack_public_path__ + "images/thanks.png?484a617693d34313c4b14260026eff26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thanks.png
// module id = uGic
// module chunks = 0